export const TOGGLE_APP_CLICK_CATCHER = 'TOGGLE_APP_CLICK_CATCHER';
export const TOGGLE_PLAIN_TEXT_MODAL = 'TOGGLE_PLAIN_TEXT_MODAL';
export const TOGGLE_BRANDING_PQL = 'TOGGLE_BRANDING_PQL';
export const TOGGLE_EXIT_WITH_CHANGES_MODAL = 'TOGGLE_EXIT_WITH_CHANGES_MODAL';
export const TOGGLE_VERIFY_EMAIL_ADDRESS_MODAL = 'TOGGLE_VERIFY_EMAIL_ADDRESS_MODAL';
export const FETCH_PORTAL_EMAIL_STATUS_STARTED = 'FETCH_PORTAL_EMAIL_STATUS_STARTED';
export const FETCH_PORTAL_EMAIL_STATUS_SUCCEEDED = 'FETCH_PORTAL_EMAIL_STATUS_SUCCEEDED';
export const FETCH_PORTAL_EMAIL_STATUS_FAILED = 'FETCH_PORTAL_EMAIL_STATUS_FAILED';
export const TOGGLE_CREDIT_LIMIT_REACHED_MODAL = 'TOGGLE_CREDIT_LIMIT_REACHED_MODAL';
export const CREATE_SMART_EMAIL_FIELD_DEFINITION = 'CREATE_SMART_EMAIL_FIELD_DEFINITION';
export const UPDATE_SMART_EMAIL_FIELD_RULE = 'UPDATE_SMART_EMAIL_FIELD_RULE';
export const CREATE_SMART_EMAIL_FIELD_RULE = 'CREATE_SMART_EMAIL_FIELD_RULE';
export const REMOVE_SMART_EMAIL_FIELD_DEFINITION = 'REMOVE_SMART_EMAIL_FIELD_DEFINITION';
export const UPDATE_SMART_EMAIL_FIELD_RULES = 'UPDATE_SMART_EMAIL_FIELD_RULES';
export const TOGGLE_CONTENT_REMIX_MODAL = 'TOGGLE_CONTENT_REMIX_MODAL';
export const UPDATE_MODULE_SMART_RULES = 'UPDATE_MODULE_SMART_RULES';
export const RECEIVE_SOCIAL_NETWORKS = 'RECEIVE_SOCIAL_NETWORKS';
export const UPDATE_AB_TEST_SETTINGS = 'UPDATE_AB_TEST_SETTINGS';
export const UPDATE_RECIPIENTS_DATA = 'UPDATE_RECIPIENTS_DATA';
export const UPDATE_JITTER_ENABLED = 'UPDATE_JITTER_ENABLED';
export const UPDATE_EMAIL_THROTTLE_SEND_SPEED = 'UPDATE_EMAIL_THROTTLE_SEND_SPEED';
export const UPDATE_PREVIEW_TEXT_SPACING_ENABLED = 'UPDATE_PREVIEW_TEXT_SPACING_ENABLED';
export const UPDATE_CONTENT_MODEL_TRACKING_SETTINGS_VALUE = 'UPDATE_CONTENT_MODEL_TRACKING_SETTINGS_VALUE';
export const TOGGLE_IMPORT_CONTACTS_MODAL_OPEN = 'TOGGLE_IMPORT_CONTACTS_MODAL_OPEN';
export const TOGGLE_SHOW_IMPORT_CONTACTS_ALERT = 'TOGGLE_SHOW_IMPORT_CONTACTS_ALERT';
export const TOGGLE_CAN_SPAM_MODAL = 'TOGGLE_CAN_SPAM_MODAL';
export const UPDATE_CAN_SPAM_SETTINGS_STARTED = 'UPDATE_CAN_SPAM_SETTINGS_STARTED';
export const FETCH_EMAIL_WORKFLOWS_STARTED = 'FETCH_EMAIL_WORKFLOWS_STARTED';
export const FETCH_EMAIL_WORKFLOWS_SUCCEEDED = 'FETCH_EMAIL_WORKFLOWS_SUCCEEDED';
export const FETCH_EMAIL_WORKFLOWS_FAILED = 'FETCH_EMAIL_WORKFLOWS_FAILED';
export const CREATE_SIMPLE_WORKFLOW_STARTED = 'CREATE_SIMPLE_WORKFLOW_STARTED';
export const CREATE_SIMPLE_WORKFLOW_SUCCEEDED = 'CREATE_SIMPLE_WORKFLOW_SUCCEEDED';
export const CREATE_SIMPLE_WORKFLOW_FAILED = 'CREATE_SIMPLE_WORKFLOW_FAILED';
export const SIMPLE_WORKFLOW_DELETED = 'SIMPLE_WORKFLOW_DELETED';
export const CLEAR_SIMPLE_WORKFLOWS = 'CLEAR_SIMPLE_WORKFLOWS';
export const TOGGLE_WORKFLOW_ON = 'TOGGLE_WORKFLOW_ON';
export const TOGGLE_WORKFLOW_OFF = 'TOGGLE_WORKFLOW_OFF';
export const UPDATE_FLOW_NAME = 'UPDATE_FLOW_NAME';
export const FETCH_SIMPLE_WORKFLOWS_REQUEST = 'FETCH_SIMPLE_WORKFLOWS_REQUEST';
export const FETCH_SIMPLE_WORKFLOWS_STARTED = 'FETCH_SIMPLE_WORKFLOWS_STARTED';
export const FETCH_SIMPLE_WORKFLOWS_SUCCEEDED = 'FETCH_SIMPLE_WORKFLOWS_SUCCEEDED';
export const FETCH_SIMPLE_WORKFLOWS_FAILED = 'FETCH_SIMPLE_WORKFLOWS_FAILED';
export const FETCH_BLOGS_SUCCEEDED = 'FETCH_BLOGS_SUCCEEDED';
export const FETCH_USERS_STARTED = 'FETCH_USERS_STARTED';
export const FETCH_USERS_SUCCEEDED = 'FETCH_USERS_SUCCEEDED';
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';
export const FETCH_EMAIL_VALIDATION_STARTED = 'FETCH_EMAIL_VALIDATION_STARTED';
export const FETCH_EMAIL_VALIDATION_SUCCEEDED = 'FETCH_EMAIL_VALIDATION_SUCCEEDED';
export const FETCH_EMAIL_VALIDATION_FAILED = 'FETCH_EMAIL_VALIDATION_FAILED';
export const FETCH_EMAIL_VALIDATION_NOT_REQUIRED = 'FETCH_EMAIL_VALIDATION_NOT_REQUIRED';
export const VERIFY_EMAIL_ADDRESS_STARTED = 'VERIFY_EMAIL_ADDRESS_STARTED';
export const VERIFY_EMAIL_ADDRESS_SUCCEEDED = 'VERIFY_EMAIL_ADDRESS_SUCCEEDED';
export const VERIFY_EMAIL_ADDRESS_FAILED = 'VERIFY_EMAIL_ADDRESS_FAILED';
export const ADD_FROM_NAME_STARTED = 'ADD_FROM_NAME_STARTED';
export const ADD_FROM_NAME_SUCCEEDED = 'ADD_FROM_NAME_SUCCEEDED';
export const ADD_FROM_NAME_FAILED = 'ADD_FROM_NAME_FAILED';
export const ADD_FROM_NAME_RESET = 'ADD_FROM_NAME_RESET';
export const REMOVE_FROM_NAME_STARTED = 'REMOVE_FROM_NAME_STARTED';
export const REMOVE_FROM_NAME_SUCCEEDED = 'REMOVE_FROM_NAME_SUCCEEDED';
export const REMOVE_FROM_NAME_FAILED = 'REMOVE_FROM_NAME_FAILED';
export const REMOVE_FROM_NAME_RESET = 'REMOVE_FROM_NAME_RESET';
export const START_EMAIL_ONBOARDING = 'START_EMAIL_ONBOARDING';
export const RESTART_EMAIL_ONBOARDING = 'RESTART_EMAIL_ONBOARDING';
export const SET_ONBOARDING_TOUR_ACTIVE = 'SET_ONBOARDING_TOUR_ACTIVE';
export const CANCEL_EMAIL_ONBOARDING_DISMISS = 'CANCEL_EMAIL_ONBOARDING_DISMISS';
export const FETCH_CONDITIONALLY_PUBLISH_STARTED = 'FETCH_CONDITIONALLY_PUBLISH_STARTED';
export const FETCH_CONDITIONALLY_PUBLISH_SUCCEEDED = 'FETCH_CONDITIONALLY_PUBLISH_SUCCEEDED';
export const FETCH_CONDITIONALLY_PUBLISH_FAILED = 'FETCH_CONDITIONALLY_PUBLISH_FAILED';
export const FETCH_IS_CONVERTIBLE_TO_DD_STARTED = 'FETCH_IS_CONVERTIBLE_TO_DD_STARTED';
export const FETCH_IS_CONVERTIBLE_TO_DD_SUCCEEDED = 'FETCH_IS_CONVERTIBLE_TO_DD_SUCCEEDED';
export const FETCH_IS_CONVERTIBLE_TO_DD_FAILED = 'FETCH_IS_CONVERTIBLE_TO_DD_FAILED';
export const FETCH_CUSTOM_OBJECTS_STARTED = 'FETCH_CUSTOM_OBJECTS_STARTED';
export const FETCH_CUSTOM_OBJECTS_SUCCEEDED = 'FETCH_CUSTOM_OBJECTS_SUCCEEDED';
export const FETCH_CUSTOM_OBJECTS_FAILED = 'FETCH_CUSTOM_OBJECTS_FAILED';
export const FETCH_DKIM_DOMAINS_STARTED = 'FETCH_DKIM_DOMAINS_STARTED';
export const FETCH_DKIM_DOMAINS_SUCCEEDED = 'FETCH_DKIM_DOMAINS_SUCCEEDED';
export const FETCH_DKIM_DOMAINS_FAILED = 'FETCH_DKIM_DOMAINS_FAILED';
export const FETCH_DOMAINS_STARTED = 'FETCH_DOMAINS_STARTED';
export const FETCH_DOMAINS_SUCCEEDED = 'FETCH_DOMAINS_SUCCEEDED';
export const FETCH_DOMAINS_FAILED = 'FETCH_DOMAINS_FAILED';
export const FETCH_PRODUCTS_COUNT_STARTED = 'FETCH_PRODUCTS_COUNT_STARTED';
export const FETCH_PRODUCTS_COUNT_SUCCEEDED = 'FETCH_PRODUCTS_COUNT_SUCCEEDED';
export const FETCH_PRODUCTS_COUNT_FAILED = 'FETCH_PRODUCTS_COUNT_FAILED';
export const FETCH_DATA_PRIVACY_SETTINGS_SUCCESS = 'FETCH_DATA_PRIVACY_SETTINGS_SUCCESS';
export const FETCH_RECIPIENT_FATIGUE_SETTINGS = 'FETCH_RECIPIENT_FATIGUE_SETTINGS';

// saved sections
export const FETCH_SAVED_SECTIONS_STARTED = 'FETCH_SAVED_SECTIONS_STARTED';
export const FETCH_SAVED_SECTIONS_FAILED = 'FETCH_SAVED_SECTIONS_FAILED';
export const FETCH_SAVED_SECTIONS_SUCCEEDED = 'FETCH_SAVED_SECTIONS_SUCCEEDED';
export const FETCH_SAVED_SECTION_META_STARTED = 'FETCH_SAVED_SECTION_META_STARTED';
export const FETCH_SAVED_SECTION_META_FAILED = 'FETCH_SAVED_SECTION_META_FAILED';
export const FETCH_SAVED_SECTION_META_SUCCEEDED = 'FETCH_SAVED_SECTION_META_SUCCEEDED';
export const UPDATE_SAVED_SECTION_THUMBNAIL = 'UPDATE_SAVED_SECTION_THUMBNAIL';
export const SAVE_SECTION_REQUEST_STARTED = 'SAVE_SECTION_REQUEST_STARTED';
export const SAVE_SECTION_REQUEST_FAILED = 'SAVE_SECTION_REQUEST_FAILED';
export const SAVE_SECTION_REQUEST_SUCCEEDED = 'SAVE_SECTION_REQUEST_SUCCEEDED';

// sidebar
export const OPEN_EMAIL_SIDEBAR = 'OPEN_EMAIL_SIDEBAR';
export const SELECT_INBOX_CONTENT = 'SELECT_INBOX_CONTENT';
export const HIGHLIGHT_INBOX_SECTION = 'HIGHLIGHT_INBOX_SECTION';
export const SELECT_SEND_OPTIONS = 'SELECT_SEND_OPTIONS';

// Experiments
export const ADVANCED_PQL_LOCATION = 'ADVANCED_PQL_LOCATION';

// Litmus
export const CREATE_LITMUS_TEST_FAIL = 'CREATE_LITMUS_TEST_FAIL';
export const CREATE_LITMUS_TEST_SUCCESS = 'CREATE_LITMUS_TEST_SUCCESS';
export const FETCH_LITMUS_CLIENTS_STARTED = 'FETCH_LITMUS_CLIENTS_STARTED';
export const FETCH_LITMUS_CLIENTS_FAILED = 'FETCH_LITMUS_CLIENTS_FAILED';
export const FETCH_LITMUS_CLIENTS_SUCCEEDED = 'FETCH_LITMUS_CLIENTS_SUCCEEDED';
export const FETCH_LITMUS_HISTORY_FAILED = 'FETCH_LITMUS_HISTORY_FAILED';
export const FETCH_LITMUS_LIMITS_FAIL = 'FETCH_LITMUS_LIMITS_FAIL';
export const FETCH_LITMUS_LIMITS_SUCCESS = 'FETCH_LITMUS_LIMITS_SUCCESS';
export const LITMUS_LIMIT_INFO_CHANGED = 'LITMUS_LIMIT_INFO_CHANGED';
export const SELECT_LITMUS_TEST_RESULTS = 'SELECT_LITMUS_TEST_RESULTS';
export const FETCH_LITMUS_HISTORY_STARTED = 'FETCH_LITMUS_HISTORY_STARTED';
export const START_LITMUS_TEST_CREATION = 'START_LITMUS_TEST_CREATION';
export const UPDATE_LITMUS_CLIENT_SEARCH = 'UPDATE_LITMUS_CLIENT_SEARCH';
export const FETCH_LITMUS_HISTORY_SUCCEEDED = 'FETCH_LITMUS_HISTORY_SUCCEEDED';

// Email Template Actions
export const FETCH_EMAIL_TEMPLATE_VALIDATION_STARTED = 'FETCH_EMAIL_TEMPLATE_VALIDATION_STARTED';
export const FETCH_EMAIL_TEMPLATE_VALIDATION_SUCCEEDED = 'FETCH_EMAIL_TEMPLATE_VALIDATION_SUCCEEDED';
export const FETCH_EMAIL_TEMPLATE_VALIDATION_FAILED = 'FETCH_EMAIL_TEMPLATE_VALIDATION_FAILED';
export const CREATE_EMAIL_FROM_TEMPLATE_STARTED = 'CREATE_EMAIL_FROM_TEMPLATE_STARTED';
export const CREATE_EMAIL_FROM_TEMPLATE_SUCCEEDED = 'CREATE_EMAIL_FROM_TEMPLATE_SUCCEEDED';
export const CREATE_EMAIL_FROM_TEMPLATE_FAILED = 'CREATE_EMAIL_FROM_TEMPLATE_FAILED';
export const FETCH_DEDICATED_IP_SETUP_SETTINGS_STARTED = 'FETCH_DEDICATED_IP_SETUP_SETTINGS_STARTED';
export const FETCH_DEDICATED_IP_SETUP_SETTINGS_SUCCEEDED = 'FETCH_DEDICATED_IP_SETUP_SETTINGS_SUCCEEDED';
export const FETCH_DEDICATED_IP_SETUP_SETTINGS_FAILED = 'FETCH_DEDICATED_IP_SETUP_SETTINGS_FAILED';
export const FETCH_PAYMENT_ELIGIBILITY_STARTED = 'FETCH_PAYMENT_ELIGIBILITY_STARTED';
export const FETCH_PAYMENT_ELIGIBILITY_SUCCEEDED = 'FETCH_PAYMENT_ELIGIBILITY_SUCCEEDED';
export const FETCH_PAYMENT_ELIGIBILITY_FAILED = 'FETCH_PAYMENT_ELIGIBILITY_FAILED';
export const RESTORE_REVISIONS_STARTED = 'RESTORE_REVISIONS_STARTED';
export const RESTORE_REVISIONS_SUCCEEDED = 'RESTORE_REVISIONS_SUCCEEDED';
export const RESTORE_REVISIONS_FAILED = 'RESTORE_REVISIONS_FAILED';
export const TOGGLE_EDITOR_DARK_MODE = 'TOGGLE_EDITOR_DARK_MODE';
export const TOGGLE_PLAIN_TEXT_VERSION = 'TOGGLE_PLAIN_TEXT_VERSION';
export const DUMMY_ACTION = '@@dummy';
export const SET_IS_TEST_SEND_MODE = 'SET_IS_TEST_SEND_MODE';
export const CONTACT_QUALITY_SCORE_SEGMENT = {
  TOP_25_PERCENTILE_SEGMENT: 'TOP_25_PERCENTILE_SEGMENT',
  TOP_50_PERCENTILE_SEGMENT: 'TOP_50_PERCENTILE_SEGMENT',
  TOP_75_PERCENTILE_SEGMENT: 'TOP_75_PERCENTILE_SEGMENT',
  TOP_100_PERCENTILE_SEGMENT: 'TOP_100_PERCENTILE_SEGMENT'
};